import React from 'react';
import { BookingDetailsModal } from '../../ScheduledBookings';
import { NO_SCHEDULED_HOURS } from './scheduledHours';
import type { CostCentre, Project, TimesheetEntry } from '@/types/timesheet';

export interface BookingDetailsDialogProps {
  selectedBookingForDetails: TimesheetEntry | null;
  setSelectedBookingForDetails: React.Dispatch<React.SetStateAction<TimesheetEntry | null>>;
  setSelectedBookingForDismiss: React.Dispatch<React.SetStateAction<TimesheetEntry | null>>;
  allAvailableProjects: Project[];
  costCentres: CostCentre[];
  entries: TimesheetEntry[];
  isReadOnly: boolean;
}

/** Details of a scheduled booking row, with a hand-off to the dismiss modal. */
export function BookingDetailsDialog({
  selectedBookingForDetails,
  setSelectedBookingForDetails,
  setSelectedBookingForDismiss,
  allAvailableProjects,
  costCentres,
  entries,
  isReadOnly,
}: BookingDetailsDialogProps) {
  if (!selectedBookingForDetails) return null;

  return (
    <BookingDetailsModal
      open={!!selectedBookingForDetails}
      onOpenChange={(open) => !open && setSelectedBookingForDetails(null)}
      booking={{
        projectName: allAvailableProjects.find(p => p.id === selectedBookingForDetails.projectId)?.name || 'Unknown Project',
        costCentreName: costCentres.find(cc => cc.id === selectedBookingForDetails.costCentreId)?.name || 'Unknown Cost Centre',
        scheduledHours: selectedBookingForDetails.scheduledHours || NO_SCHEDULED_HOURS,
        bookingCreatedByName: selectedBookingForDetails.bookingCreatedByName,
        bookingCreatedAt: selectedBookingForDetails.bookingCreatedAt,
        bookingNotes: selectedBookingForDetails.bookingNotes,
      }}
      onDismiss={() => {
        const index = entries.findIndex(e => e.id === selectedBookingForDetails.id);
        if (index !== -1) {
          setSelectedBookingForDismiss(selectedBookingForDetails);
          setSelectedBookingForDetails(null);
        }
      }}
      readOnly={isReadOnly}
    />
  );
}
